import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "932aba70-7012-4dac-9e52-37ca325a7836",
  publicId: "17",
  name: "Unidirectional electrodynamic microphone",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
